export default "__VITE_ASSET__5302ab09__"